<template>
    <div class="mt-0">
        <banner v-if="bannerOn"></banner>
        <navigation :banner-on="bannerOn"></navigation>
        <div class="container-spacing">
            <slot></slot>
        </div>
        <foot></foot>
    </div>
</template>

<script>
    import Navigation from '@nextgenmath/js/components/Navigation.vue';
    import Foot from '@nextgenmath/js/components/Foot.vue';
    import Banner from '../components/Banner.vue';
    import { computed } from 'vue';

    export default {
        data: () => ({
            showBanner: true,
            windowWidth: window.innerWidth,
        }),
        provide() {
            return {
                /**
                 * Provide so child components can adjust accordingly to 
                 * the current view size.
                 */
                isMobile: computed(() => this.mobileView),
            };
        },
        methods: {
            onResize() {
                this.windowWidth = window.innerWidth;
            },
        },
        computed: {
            mobileView() {
                return this.windowWidth <= 990;
            },
            bannerOn() {
                return this.showBanner && (!this.computedUser || this.computedUser && this.computedUser.role != 'student')
            },
            computedUser() {
                if (this.$page) 
                    return this.$page.props.user;
                
                return this.user;
            },
        },
        mounted() {
            window.addEventListener('resize', this.onResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize)
        },
        components: {
            Banner,
            Navigation,
            Foot,
        }
    }
</script>

<style lang="scss">

.container-spacing {
    padding-bottom: 1em;
    margin-top: 5rem; // announcement banner on

    @media (min-width: 992px) {	
        // margin-top: 5rem; // announcement banner off
        margin-top: 8rem; // announcement banner on
    }
}
</style>
